/* @flow strict */

import * as React from 'react';
import SimpleSelect from '/client/src/components/forms/select';
import { GET, POST } from '/client/src/api';

type PropsType = {
    eventId: number | string
};

const MapLabels = ({ eventId }: PropsType): React.Element<'div'> => {
    const [isLoading, setLoading] = React.useState(false);
    const [tickets, setTickets] = React.useState([]);

    React.useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setLoading(true);
            const { result } = await GET(`/api/v1/1/events/${eventId}/ticketlabel?max_result_count=200&skip_count=0`);

            setTickets(result);

            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };
    const updateBadgeLabel = async (attendeeId: string, badgeLabel: string) => {
        try {
            setLoading(true);
            const { result } = await POST(`/api/v1/1/events/${eventId}/ticketlabel/${attendeeId}?badgelabel=${badgeLabel}`);

            setTickets(result);

            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    return (
        <div className='panel map-labels'>
            {isLoading && <div className='csspinner' />}
            <table>
                <thead>
                    <tr>
                        <th>Ticket Name</th>
                        <th>Ticket Label</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tickets.map((ticket: {}): any => (
                            <tr key={ticket.id}>
                                <td>{ticket.name}</td>
                                <td>{
                                     <SimpleSelect
                                       value={ticket.id}
                                       callBack={(e: any) => {
                                        updateBadgeLabel(ticket.id, e.target.value);
                                       }}
                                       items={ticket.badge_label}
                                     />
                                    }</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
};

export default MapLabels;